(() => {
  const initialise = () => document.querySelectorAll('[data-boat-locality-map]').forEach((map) => {
    if (map.dataset.bound) return;
    const root = map.closest('.ew-atlas--boat');
    const dialog = root?.querySelector('[data-boat-map-dialog]');
    const open = map.querySelector('[data-map-open]');
    const close = dialog?.querySelector('[data-map-close]');
    if (!dialog || !open || !close) return;
    map.dataset.bound = 'true';
    open.addEventListener('click', () => {
      const frame = dialog.querySelector('iframe[data-src]');
      if (frame && !frame.getAttribute('src')) frame.src = frame.dataset.src;
      dialog.showModal();
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => open.focus({ preventScroll: true }));
  });
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
